module.exports = __webpack_public_path__ + "static/media/yy2.bfa1b31c.png";